import React from 'react';
import format from 'date-fns/format';
import es from 'date-fns/locale/es';

const ResumenMinMax = ({ datos, filtro }) => {
    if (!datos || !datos.minimo || !datos.maximo) {
        return null;
    }

    const formatearFecha = (fecha, tipoFiltro) => {
        if (!fecha) return '-';
        const date = new Date(fecha);

        if (tipoFiltro === "semana") {
            return format(date, 'EEEE', { locale: es });
        } else {
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            return `${day}/${month}/${year} ${hours}:${minutes}`;
        }
    };

    return (
        <div className="card shadow-sm mb-4">
            <div className="card-body p-3">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h6 className="card-title fw-semibold mb-0">Resumen de Datos</h6>
                    <h6 className="fw-bold mb-0">Sensor: {datos.sensorId}</h6>
                </div>
                <div className="table-responsive">
                    <table className="table table-sm table-striped table-bordered mb-0">
                        <thead className="table-light">
                            <tr>
                                <th>Dato</th>
                                <th>Valor</th>
                                <th>Fecha/Hora</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Promedio</td>
                                <td>{datos.promedio !== null ? datos.promedio.toFixed(2) : '-'}</td>
                                <td>-</td>
                            </tr>
                            <tr>
                                <td>Mínimo</td>
                                <td>{datos.minimo.valor !== null ? datos.minimo.valor : '-'}</td>
                                <td>{formatearFecha(datos.minimo.fechaHora, filtro)}</td>
                            </tr>
                            <tr>
                                <td>Máximo</td>
                                <td>{datos.maximo.valor !== null ? datos.maximo.valor : '-'}</td>
                                <td>{formatearFecha(datos.maximo.fechaHora, filtro)}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default ResumenMinMax;